<template>
  <v-container fluid>
    <ConfirmationDialog ref="confirm" :function-yes="bindingFunction" text="¿Continuar sin guardar los cambios?"></ConfirmationDialog>
    <v-toolbar class="header-element">
      <v-toolbar-title>Configuración de íconos por área</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="sendChanges" :disabled="!isModified">Guardar</v-btn>
    </v-toolbar>
    <v-card>
      <v-subheader>Instrucciones</v-subheader>
      <v-card-text class="pt-1">
        <div class="mb-2">
          <span class="white-space">Ingrese el nombre del ícono que quiera para asignárselo a un área.</span>
          <span>A continuación se listan los íconos soportados con ejemplos:</span>
        </div>
        <div class="mb-2">
          <span><a href="https://material.io/icons" target="_blank"><b>Material Design Icons Nativo</b></a></span>
          <span>: nombre del ícono directo. Por ejemplo: <b>bookmark</b></span>
        </div>
        <div class="mb-2">
          <span><a href="https://materialdesignicons.com" target="_blank"><b>Material Design Icons Extendido</b></a></span>
          <span>: agregar el prefijo <b>mdi-</b> al nombre del ícono. Por ejemplo: <b>mdi-soccer-field</b></span>
        </div>
        <div class="mb-2">
          <span><a href="https://fontawesome.com/icons" target="_blank"><b>Font Awesome Icons</b></a></span>
          <span>: agregar el prefijo <b>fa-</b> al nombre del ícono. Por ejemplo: <b>fa-archway</b></span>
        </div>
      </v-card-text>
    </v-card><br>
      <v-flex xs12>
        <v-card v-for="area in areas" :key="area.pk">
          <v-layout row>
            <v-flex xs6 pt-1 pl-4>
              <v-text-field flat label="Nombre del ícono" v-model="area.icono" :append-outer-icon="area.icono"
                            @keydown="getModified(area)"></v-text-field>
            </v-flex>
            <v-flex xs6 pt-2>
              <v-card-title >{{ area.nombre }}</v-card-title>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </v-card>
      </v-flex>
  </v-container>
</template>

<script>
import ConfirmationDialog from '../../ui/ConfirmationDialog'

export default {
  components: {
    ConfirmationDialog
  },

  data () {
    return {
      areas: [],
      changes: {},
      bindingFunction: null
    }
  },

  computed: {
    isModified () {
      for (let pkArea in this.changes) {
        if (this.isModifiedArea(this.changes[pkArea])) {
          return true
        }
      }
      return false
    }
  },

  methods: {
    fetchData () {
      this.axios
        .get('areas')
        .then(response => {
          this.areas = response.data
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    getModified (area) {
      if (!this.changes.hasOwnProperty(area.pk)) {
        this.$set(this.changes, area.pk, { pk: area.pk, icono: area.icono })
      }
    },
    getArea (id) {
      return this.areas.find((e) => e.pk === id)
    },
    isModifiedArea (area) {
      return area.icono !== this.getArea(area.pk).icono
    },
    sendChanges () {
      for (let pkArea in this.changes) {
        let changeArea = this.changes[pkArea]
        if (this.isModifiedArea(changeArea)) {
          let area = this.getArea(changeArea.pk)
          let payload = {
            area: area.pk,
            icono: area.icono
          }
          this.axios
            .put(`areas/set_icon/${pkArea}`, payload)
            .then((response) => (this.$delete(this.changes, response.data.pk)))
            .catch(error => { this.$store.commit('setErrorMsg', error) })
        }
      }
    }
  },

  mounted () {
    this.fetchData()
  },

  beforeRouteLeave (to, from, next) {
    if (this.isModified) {
      this.bindingFunction = next
      this.$refs.confirm.openDialog()
    } else {
      next()
    }
  }
}
</script>

<style scoped>
.white-space {
  padding-right: 0.25em;
}
.header-element {
  background-color: #293968;
  color: white;
}
</style>
